import {debounce, isInViewport, isInViewportArea, isInViewportOffset, showFromFade, throttle, loadLibrary} from "../../js/Util";
import {LIB_URL} from '../../js/App';

let clientsSplide;
let featuresSplide;

if ($(".js-clients-ticker").length) {
    loadLibrary([
        LIB_URL.SPLIDE,
        LIB_URL.SPLIDE_AUTO_SCROLL
    ], () => {
        $(".js-clients-ticker").each(function (index) {
            $(this).addClass(`js-ticker-${index}`);
            const slideQuantity = $(`.js-ticker-${index}`).find(
                ".splide__slide"
            ).length;

            clientsSplide = new window.Splide(`.js-ticker-${index}`, {
                type: "loop",
                // autoWidth: true,
                fixedWidth: "5%",
                pagination: false,
                arrows: false,
                focus: "center",
                clones: slideQuantity * 3,
                gap: 90,
                drag: false,
                rewind: false,
                autoScroll: {
                    pauseOnFocus: false,
                    pauseOnHover: false,
                },
                breakpoints: {
                    1920: {
                        clones: slideQuantity * 2,
                    },
                    1099: {
                        clones: slideQuantity,
                        fixedWidth: "30%",
                        gap: 50,
                    },
                },
            }).mount(window.splide.Extensions);
        });
    });

}

if ($(".js-features-slider").length) {
    loadLibrary([
        LIB_URL.SPLIDE,
        LIB_URL.SPLIDE_AUTO_SCROLL
    ], () => {
        $(".js-features-slider").each(function (index) {
            $(this).addClass(`js-features-slider-${index}`);

            featuresSplide = new Splide(`.js-features-slider-${index}`, {
                type: "loop",
                interval: 3000,
                arrows: false,
                autoplay: true,
                drag: false,
                gap: 40,
                breakpoints: {
                    767: {
                        drag: true,
                    },
                },
            }).mount();
        });
    });
}

App.D.ready(() => {
    $(".js-scrolling-lottie").each((index, image) => {
        const scrollLottie = () => {
            if (isInViewport(image)) {
                image.play();
            } else {
                image.pause();
            }
        };

        scrollLottie();
        const scrollLottieDebounce = debounce(() => {
            scrollLottie();
        }, 50);
        window.addEventListener(
            "scroll",
            () => {
                scrollLottieDebounce();
            },
            false
        );
    });
});

if ($(".js-economy-chart").length) {
    setTimeout(() => {
        $(".js-economy-chart").addClass("_economy-active");
    }, 1000);
}

if ($(".js-support-chat").length) {
    const mainSupport = $(".js-support-chat");

    mainSupportLoop(mainSupport);
    setInterval(() => {
        mainSupportLoop(mainSupport);
    }, 17000);
}

function mainSupportLoop(mainSupport) {
    mainSupport.addClass("_support1-active");
    setTimeout(() => {
        mainSupport.addClass("_support2-active");
    }, 4000);
    setTimeout(() => {
        mainSupport.addClass("_support3-active");
    }, 8000);

    setTimeout(() => {
        mainSupport.removeClass(
            "_support1-active _support2-active _support3-active"
        );
    }, 16000);
}

if ($(".js-main-steps").length) {
    const mainSteps = $(".js-main-steps");

    let timerStep1 = setInterval(() => {
        setTimeout(() => {
            mainSteps.addClass("_step2-active");
        }, 2000);
        setTimeout(() => {
            mainSteps.addClass("_step22-active");
        }, 3500);
        setTimeout(() => {
            mainSteps.addClass("_step3-active");
        }, 6000);

        setTimeout(() => {
            mainSteps.removeClass("_step2-active _step22-active _step3-active");
        }, 8500);
    }, 9000);
}

if ($(".js-payment-slider").length) {
    loadLibrary([
        LIB_URL.SPLIDE,
        LIB_URL.SPLIDE_AUTO_SCROLL
    ], () => {
        $(".js-payment-slider").each(function (index) {
            $(this).addClass(`js-payment-slider-${index}`);

            new Splide(`.js-payment-slider-${index}`, {
                pagination: false,
                type: "fade",
                rewind: true,
                // autoplay: true,
                interval: 3000,
            }).mount();
        });
    });
}

if ($(".js-main-results").length) {
    $(".js-main-results").each(function () {
        const mainResults = $(this);
        const mainResultsTabs = $(this).find(".result-tabs__item");
        let index = 0;

        const mainResultsChangeTabs = () => {
            mainResults
                .removeClass("_active-1 _active-2 _active-3 _active-4")
                .addClass("_active-" + (index + 1));
            index = index < mainResultsTabs.length - 1 ? index + 1 : 0;
        };

        mainResultsChangeTabs();
        let mainResultsRepeat = setInterval(mainResultsChangeTabs, 2500);

        mainResultsTabs.on("click", function () {
            clearInterval(mainResultsRepeat);
            index = $(this).data("id");
            mainResults
                .removeClass("_active-1 _active-2 _active-3 _active-4")
                .addClass("_active-" + (index + 1));

            setTimeout(() => {
                mainResultsRepeat = setInterval(mainResultsChangeTabs, 2500);
            }, 500);
        });
    });
}

App.H.on("click", ".js-video-block", function () {
    initVideo($(this));
});
// if (App.H.hasClass("page-use-case")) {
//     if ($(".js-video-block").length) {
//         $(".js-video-block").each(function () {
//             initVideo($(this));
//         });
//     }
// }
function initVideo($video) {
    const $videoBlock = $video;
    const videoData = {
        player: $videoBlock.data("player"),
        id: $videoBlock.data("video-id"),
    };
    let video;
    $videoBlock.addClass("_video-active");

    if (videoData.player === "vimeo") {
        if (App.H.hasClass('mobile') || App.W.width < 768) {
            video = `<iframe class="video-embed" src="https://player.vimeo.com/video/${videoData.id}?h=9d12e0090f&title=0&byline=0&autoplay=1&color=0055fe&muted=1&controls=0&loop=1" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`;
        } else {
            video = `<iframe class="video-embed" src="https://player.vimeo.com/video/${videoData.id}?h=9d12e0090f&title=0&byline=0&autoplay=1&color=0055fe&muted=1" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`;
        }
    } else if (videoData.player === 'vk') {
        video = `<iframe src="https://vk.com/video_ext.php?oid=-${videoData.id}&autoplay=1" allow="autoplay; encrypted-media; fullscreen; picture-in-picture; screen-wake-lock;" frameBorder="0" width="100%" height="100%" allowFullScreen></iframe>`;
    } else {
        video = `<iframe class="video-embed" src="https://www.youtube.com/embed/${videoData.id}?si=228ieeyc3plhMiQD&title=0&autoplay=1&mute=1" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>`;
    }
    $videoBlock.append(video);
}

if ($(".main-block").length && $(".main-columns").length) {
    $(".main-columns")
        .find(".equal-columns__item")
        .each((index, column) =>
            $(column).addClass("equal-columns__item-" + index)
        );

    $(".main-columns")
        .find(".main-block")
        .each((index, item) => {
            const start =
                $(document).width() >= 768
                    ? "top bottom-=20%"
                    : "top bottom-=10%";
            showFromFade(item, start);
        });
}

if ($(".js-main-mobile-hide").length) {
    const $mobileContainer = $(".js-main-blocks-mobile");
    const removingBlocks = App.D.find($(".js-main-mobile-hide"));

    const removeMainBlocks = () => {
        if (App.W.width() < 768) {
            if (!$mobileContainer.hasClass("_active")) {
                removingBlocks.each((index, item) => {
                    const lottieTemp = $(item).find("lottie-player");
                    const lottieTempUrl = $(lottieTemp).attr('src');
                    const lottieTempParent = $(lottieTemp).closest("div");

                    $(item).after(
                        `<div class="_hidden" data-block="${$(item).data(
                            "block"
                        )}"></div>`
                    );
                    $mobileContainer.addClass("_active").append(item);
                    $(item).addClass("_mob-hidden");

                    $(item)
                        .addClass("_mob-column-changed")
                        .find(lottieTempParent)
                        .append(lottieTemp);

                    if ($(item).find('#economy-lottie').length) {
                        const player = document.querySelector('#economy-lottie');
                        player.load(lottieTempUrl);
                    }
                });
            }

            if (
                $(".equal-columns__item-1").length &&
                $(".equal-columns__item-1").find(".main-block").length > 0
            ) {
                const columnChangeBlocks = $(".equal-columns__item-1").find(
                    ".main-block"
                );
                columnChangeBlocks.each((index, item) => {
                    const lottieTemp = $(item).find("lottie-player");
                    const lottieTempUrl = $(lottieTemp).attr('src');
                    const lottieTempParent = $(lottieTemp).closest("div");

                    $(item).after(
                        `<div class="_hidden" data-block="${$(item).data(
                            "block"
                        )}"></div>`
                    );
                    $(".equal-columns__item-0").append(item);

                    $(item)
                        .addClass("_mob-column-changed")
                        .find(lottieTempParent)
                        .append(lottieTemp);

                    if ($(item).find('#economy-lottie').length) {
                        const player = document.querySelector('#economy-lottie');
                        player.load(lottieTempUrl);
                    }
                });
            }
        } else {
            $mobileContainer
                .find($(".js-main-mobile-hide"))
                .each((index, item) => {
                    const itemName = $(item).data("block");
                    $(".main-columns .equal-columns__item")
                        .find(`[data-block="${itemName}"]`)
                        .before(item)
                        .remove();
                });
            $mobileContainer.removeClass("_active").empty();

            removingBlocks.each((index, item) => {
                $(item).removeClass("_mob-hidden");
            });

            if (
                $(".equal-columns__item-1").length &&
                $(".equal-columns__item-0").find("._mob-column-changed")
                    .length > 0
            ) {
                const columnChangeBlocks = $(".equal-columns__item-0").find(
                    "._mob-column-changed"
                );

                columnChangeBlocks.each((index, item) => {
                    const lottieTemp = $(item).find("lottie-player");
                    const lottieTempUrl = $(lottieTemp).attr('src');
                    const lottieTempParent = $(lottieTemp).closest("div");
                    const itemName = $(item).data("block");
                    $(".equal-columns__item-1")
                        .find(`[data-block="${itemName}"]`)
                        .before(item)
                        .remove();

                    $(item)
                        .removeClass("_mob-column-changed")
                        .find(lottieTempParent)
                        .append(lottieTemp);
                    if ($(item).find('#economy-lottie').length) {
                        const player = document.querySelector('#economy-lottie');
                        player.load(lottieTempUrl);
                    }
                });
            }
        }
    };

    removeMainBlocks();

    const debounceResize = debounce(() => {
        removeMainBlocks();

        App.W.trigger("resized");
    }, 200);

    App.W.on("resize", () => {
        debounceResize();
    });
}

if ($(".clients").length) {
    $(".clients")
        .each((index, item) => {
            const start =
                $(document).width() >= 768
                    ? "top bottom-=20%"
                    : "top bottom-=10%";
            showFromFade(item, start);
        });
}

if ($('.main-block2--steps-bg').length) {
    const $mainBlock2StepsBg = $('.main-block2--steps-bg');
    const $mainBlock2Steps = $mainBlock2StepsBg.closest('.main-block2--steps');

    const mainBlock2StepsAnim = () => {
        if (isInViewportArea($mainBlock2Steps[0], 0.1)) {
            $mainBlock2Steps.addClass('_visible');
        }
    };

    const mainBlock2StepsDebounce = throttle(() => {
        mainBlock2StepsAnim();
    }, 200);

    mainBlock2StepsDebounce();

    window.addEventListener("load", () => {
        mainBlock2StepsDebounce();
    });

    window.addEventListener("scroll", () => {
        mainBlock2StepsDebounce();
    });
}
